import { useRef, type RefObject } from 'react';
import { useDialogFocusTrap as useSharedDialogFocusTrap } from '@quality-vet/ui/modal-focus-trap';

export function useModalDialog<T extends HTMLElement>(
  open: boolean,
  onClose: () => void,
): RefObject<T | null> {
  const dialogRef = useRef<T>(null);
  useSharedDialogFocusTrap(dialogRef, onClose, { active: open });

  return dialogRef;
}
